import { GQLIdEncoder, ModelType } from '../../../common/utils/GQLIdEncoder';
import { Project } from '../../common/models/Project';
import { Project as DashboardProject } from '../models/Project';

export class ProjectDashboardMapper {
  private readonly gqlIdEncoder = new GQLIdEncoder();

  mapToDashboardProject(project: Project): DashboardProject {
    const encodedId = this.gqlIdEncoder.encode(ModelType.Project, project.getId());

    return new DashboardProject(project.getId(), encodedId, project.getName(), project.getLastAnalysis());
  }
}
